import { State } from "./types";
import { notificationsFilter } from "@planzone/dto";

const initialState: State = {
  request: {
    isPending: false,
    isSuccessful: false,
    isFailure: false,
  },
  notifications: [],
  filter: notificationsFilter,
  totalPages: 0,
};

export { initialState };
